import React from "react";

export const DocSettingSvg = (props) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 10.8 14.3"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.9 4.9v8.5a1.8 1.8 0 01-1.8 1.8v-.9a.9.9 0 00.9-.9V4.9h-1.8a1.3 1.3 0 01-1.3-1.4V1.7H5a.9.9 0 00-.9.9v8.1h-.9V2.6A1.8 1.8 0 015 .8h4.9z"
        transform="translate(-3.2 -.8)"
      ></path>
      <path
        d="M7.7 11.3c-.2 0-.3.1-.5.3a.7.7 0 000 1l.5.2.6-.2a.7.7 0 000-1zm2.8 1.6l-.5-.4c.1-.1.1-.2.1-.4a.4.4 0 00-.1-.3l.5-.4c0-.1.1-.1 0-.2a3.1 3.1 0 00-.5-1h-.2l-.6.2-.6-.4v-.6l-.2-.2H7.2l-.2.2v.6l-.6.4-.6-.2h-.3a3.1 3.1 0 00-.5 1c-.1.1 0 .1 0 .2l.5.4a.4.4 0 00-.1.3c0 .2 0 .3.1.4l-.5.4c0 .1-.1.1 0 .2a3.1 3.1 0 00.5 1h.2l.6-.2.6.4v.6l.2.2h1.2l.2-.2v-.6l.6-.4.6.2h.3a3.1 3.1 0 00.5-1c.1-.1 0-.1 0-.2zm-2.8.3a1.1 1.1 0 01-1.1-1.1 1.1 1.1 0 011.1-1.2 1.2 1.2 0 011.2 1.2 1.1 1.1 0 01-1.2 1.1z"
        transform="translate(-3.2 -.8)"
      ></path>
    </svg>
  );
}
